// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__2IMPt","active":"downloadDropdown_active__ETXuC"};